import { Component } from '@angular/core';
import { RouterConst } from '../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { WsService } from '../../../services/websocket/WsService';
import { SuperClass } from '../../../superclass/SuperClass';
import { ClientsService } from '../../../services/clients/clients.service';
import { WsConst } from '../../../globals/WsConst';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-charts-and-summary',
  templateUrl: './charts-and-summary.component.html',
  styleUrls: ['./charts-and-summary.component.scss'],
})
export class ChartsAndSummaryComponent extends SuperClass {
  dashboardData;
  chartOptions;
  isRefreshed = false;

  newUsersData;
  sparkPieUsersNewVsRet;

  sessions;
  sparkPieSessionsNewVsRet;

  usersDataUsage;
  sparkPieDataUsage;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Dashboards' },
      {
        label: 'Charts and Summary',
        routerLink: [{ outlets: { sub: [RouterConst.CHARTS] } }],
      },
    ]);
  }

  setData(data) {
    this.dashboardData = data;
    this.chartsInit();
  }

  reloadData() {
    this.dashboardDataService.getDD('ChartsAndSummaryComponent');
  }

  getWebSocketIdentifier() {
    return WsConst.STATISTICS;
  }

  chartsInit() {
    this.chartOptions = {
      scaleFontColor: 'gray',

      legend: {
        labels: {
          fontColor: 'gray',
        },
      },

      scales: {
        xAxes: [
          {
            gridLines: {
              color: 'gray',
              display: false,
            },
            stacked: true,
          },
        ],

        yAxes: [
          {
            scaleLabel: {
              display: true,
              // labelString: 'Load in %',
              fontColor: 'gray',
            },
            gridLines: {
              color: 'gray',
              display: true,
            },
            stacked: true,
          },
        ],
      },
    };
    // Users
    this.newUsersData = {
      labels: [
        '0-6am',
        '6am',
        '7am',
        '8am',
        '9am',
        '10am',
        '11am',
        'Noon',
        '1pm',
        '2pm',
        '3pm',
        '4pm',
        '5pm',
        '6pm',
        '7pm',
        '8pm',
        '9pm',
        '> 10pm',
      ],
      datasets: [
        {
          label: this.dashboardData.charts.newVsReturning.label1,
          order: 1,
          backgroundColor: '#F6BD60',
          hoverBackgroundColor: '#FFE082',
          data: this.dashboardData.charts.newVsReturning.data1,
        },
        {
          label: this.dashboardData.charts.newVsReturning.label2,
          order: 2,
          backgroundColor: '#488BB4',
          hoverBackgroundColor: '#81D4FA',
          data: this.dashboardData.charts.newVsReturning.data2,
        },
      ],
    };

    this.sparkPieUsersNewVsRet = {
      labels: ['New users', 'Returning users'],
      datasets: [
        {
          data: this.dashboardData.charts.sparkPieUsersNewVsRet.data,
          backgroundColor: ['#F6BD60', '#488BB4'],
          hoverBackgroundColor: ['#FFE082', '#81D4FA'],
        },
      ],
    };

    // Sessions
    this.sessions = {
      labels: [
        '0-6am',
        '6am',
        '7am',
        '8am',
        '9am',
        '10am',
        '11am',
        'Noon',
        '1pm',
        '2pm',
        '3pm',
        '4pm',
        '5pm',
        '6pm',
        '7pm',
        '8pm',
        '9pm',
        '> 10pm',
      ],
      datasets: [
        {
          label: this.dashboardData.charts.sessionsByTime.label1,
          order: 1,
          backgroundColor: '#F6BD60',
          hoverBackgroundColor: '#FFE082',
          data: this.dashboardData.charts.sessionsByTime.data1,
        },
        {
          label: this.dashboardData.charts.sessionsByTime.label2,
          order: 2,
          backgroundColor: '#488BB4',
          hoverBackgroundColor: '#81D4FA',
          data: this.dashboardData.charts.sessionsByTime.data2,
        },
      ],
    };

    this.sparkPieSessionsNewVsRet = {
      labels: ['New for period', 'Returning for period'],
      datasets: [
        {
          data: this.dashboardData.charts.sparkPieSessionsNewVsRet.data,
          backgroundColor: ['#F6BD60', '#488BB4'],
          hoverBackgroundColor: ['#FFE082', '#81D4FA'],
        },
      ],
    };

    // User data
    this.usersDataUsage = {
      labels: [
        '0-6am',
        '6am',
        '7am',
        '8am',
        '9am',
        '10am',
        '11am',
        'Noon',
        '1pm',
        '2pm',
        '3pm',
        '4pm',
        '5pm',
        '6pm',
        '7pm',
        '8pm',
        '9pm',
        '> 10pm',
      ],
      datasets: [
        {
          label: this.dashboardData.charts.dataUsageByTime.label1,
          order: 1,
          backgroundColor: '#F6BD60',
          hoverBackgroundColor: '#FFE082',
          data: this.dashboardData.charts.dataUsageByTime.data1,
        },
        {
          label: this.dashboardData.charts.dataUsageByTime.label2,
          order: 2,
          backgroundColor: '#488BB4',
          hoverBackgroundColor: '#81D4FA',
          data: this.dashboardData.charts.dataUsageByTime.data2,
        },
      ],
    };

    this.sparkPieDataUsage = {
      labels: ['Download data', 'Upload data'],
      datasets: [
        {
          data: this.dashboardData.charts.sparkPieDataUsage.data,
          backgroundColor: ['#F6BD60', '#488BB4'],
          hoverBackgroundColor: ['#FFE082', '#81D4FA'],
        },
      ],
    };
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/dashboards/charts-and-summary/charts-and-summary.component.ts